module.exports = __webpack_public_path__ + "img/landing-logo.902cf63d.png";